import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  MetaMaskObj:{
    isInstall:false,
    isConnect:false,
    isJoinNet:false,
    account:null,
    initOk:false,
    FoundationManager:undefined,
    Auditor:undefined,
    chainId:process.env.VUE_APP_CHAINID,
    stopRefreshJoinNet:false
  },
  gas:"0x7a120",
  contractMap:{
    contractGovernance:{},
    contractDao:{},
    contractBid:{},
    contractTAT:{},
    contractUnitPrice:{},
    contractUSTN:{},
    contractUSTNFinance:{},
    contractExpense:{}
  },
  accountTypes:[
    {
      name:"Bitcoin Account",
      value:"BTC"
    },
    {
      name:"Ethereum Account",
      value:"ETH"
    }
  ],
  producerAuthSatatus:[
    {
      name:"Registered",
      value:0
    },
    {
      name:"In review",
      value:1
    },
    {
      name:"Passed",
      value:2
    },
    {
      name:"Not passed",
      value:3
    }
  ]
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  SET_MATEMASK: (state, obj) => {
    if(obj){
      for(let k in obj){
        state.MetaMaskObj[k] = obj[k];
      }
    }
  },
  SET_CONTRACTMAP: (state, data) => {
    state.contractMap[data.key] = data.value;
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  joinNet({ commit }, data){
    return new Promise((resolve, reject) => {
      try {
        ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: process.env.VUE_APP_CHAINID, // Fixed value, can be written to config file
              chainName: "TreasureNet Web", // Just a name that can be set to anything
              rpcUrls: JSON.parse(process.env.VUE_APP_RPC_URLS),
              nativeCurrency: {
                name: "Unit",
                symbol: "Unit", // 2-6 characters long
                decimals: 18,
              },
            },
          ],
        }).then(res => {
          resolve()
        })

      } catch (error) {
        console.log(error);
        reject();
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
